import axios from 'axios'

class Http {
    constructor() {
        this.http = axios.create({
            baseURL: GLOBALS.ajax_url,
        })
    }

    get(action, options = {}) {
        return this.http(Object.assign(options, {
            method: 'get',
            params: {
                action,
            },
        }))
    }

    post(action, data, options = {}) {

        let formData

        if (data instanceof FormData) {
            formData = data
        } else {
            formData = new FormData()
            Object.keys(data).forEach(key => {
                if (data.hasOwnProperty(key)) {
                    formData.append(key, data[key])
                }
            })
        }

        if (action) {
            formData.append('action', action)
        }

        formData.append('_wpnonce', GLOBALS.ajax_nonce)

        return this.http(Object.assign(options, {
            method: 'post',
            data: formData,
        }));
    }

}

const instance = new Http

export default instance